import Vue from 'vue';
import Vuex from 'vuex';

import authenticationModule from './modules/authentication';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth: authenticationModule
  },
});